import * as Environment from "../base/Environment.js";

import {RenderContext, AnimatableSprite} from "../base/Display2D.js";

//
// PollController extends AnimatableSprite
//

export const PollController = function (context) {
	AnimatableSprite.apply (this, arguments);

};

PollController.prototype = Object.create (AnimatableSprite.prototype);

PollController.prototype.takeElement = function (element) {
	this.element.parentNode.removeChild (this.element);
	this.element = element;

	const title = this.title = element.querySelector ("h2");

	const closeButton = element.querySelector (".view-close-button");
	closeButton.addEventListener ("click", function () {
		const stage = this.getStage ();
		stage.closeSidePanelController (this);

	}.bind (this));

	const iFrame = this.iFrame = element.querySelector ("iframe.poll-i-frame");
	const iFrameSource = this.iFrameSource = iFrame.getAttribute ("data-src");
	
	window.setTimeout (function () {
		const iFrame = this.iFrame;
		const iFrameSource = this.iFrameSource;
		
		if (iFrame.src != iFrameSource) {
			iFrame.src = iFrameSource;
			this.iFrameSource = iFrame.src;
			
		}
		
	}.bind (this), 125);
	
};

PollController.prototype.pollId = -1;

PollController.prototype.setPollId = function (pollId, delayed) {
	if (this.pollId == pollId)
		return;
	
	this.pollId = pollId;
	
	const iFrame = this.iFrame;
	let iFrameSource = this.iFrameSource;
	
	/*
	if (pollId)
		iFrameSource = iFrameSource.replace (".html", "-" + pollId + ".html");
	else
		iFrameSource = window.exparea_config.urls.chat;
	*/
	
	if (false && delayed && !pollId && !Environment.FAST_PASS) {
		iFrame.src = "about:blank";
		window.setTimeout (function () {
			if (iFrame.src != iFrameSource)
				iFrame.src = iFrameSource;
			
		}, 550);
		
	} else {
		if (iFrame.src != iFrameSource)
			iFrame.src = iFrameSource;
		
	}
	
	this.iFrameSource = iFrame.src;

};

PollController.prototype.awake = function () {
	if (this.isAwake)
		return;

	this.isAwake = true;

};

PollController.prototype.sleep = function () {
	if (!this.isAwake)
		return;

	this.isAwake = false;

};

PollController.prototype.setViewSize = function (viewSize) {
	this.viewSize = viewSize;

	const element = this.element;
	element.style.width = viewSize [0] + "px";
	element.style.height = viewSize [1] + "px";

};
